import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'

import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb'

class BreadCrumbSection extends Component {
  render() {
    const { className, breadcrumbOptions } = this.props
    return (
      <section className={className}>
        <ErrorBoundary>
          <Breadcrumb {...breadcrumbOptions} />
        </ErrorBoundary>
      </section>
    )
  }
}

BreadCrumbSection.propTypes = {
  className: PropTypes.string.isRequired,
  breadcrumbOptions: PropTypes.object.isRequired
}

export default BreadCrumbSection
